import { styled } from '@mui/material/styles';

export const Title = styled('h3')(({ theme }) => ({
  fontSize: theme.fontSize.large,
  margin: theme.spacing(1, 0, 3)
}));
